import styled from '@emotion/styled'
import { breakpoint } from '../../../__styling/style-functions/breakpoint'
import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { themedValue } from '../../../__styling/themed-value'
interface OlympicWidgetWrapStyleProps {
    isFullSize: boolean
}

export const StyledOlympicWidgetWrap = styled(
    'div',
)<OlympicWidgetWrapStyleProps>(({ theme, isFullSize }) => ({
    fontFamily: 'Guardian Sans Web',
    height: themedValue(theme, {
        thewest: '100%',
        fallback: 'auto',
    }),
    padding: calcRem(10),
    background: theme.colors.background.secondary,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    a: {
        textDecoration: 'none',
    },
    '.widget-header': {
        display: 'none',
    },
    '&:after': {
        content: themedValue(theme, {
            thewest: isFullSize ? "''" : 'none',
            fallback: 'none',
        }),
        width: '100%',
        height: calcRem(12),
        position: 'absolute',
        left: '0',
        bottom: calcRem(-12),
        background: theme.colors.background.secondary,

        [breakpoint('md')]: {
            height: '100%',
            width: calcRem(12),
            top: '0',
            right: calcRem(-12),
            left: 'unset',
            bottom: 'unset',
        },
    },
    [breakpoint('md')]: {
        padding: isFullSize ? calcRem(20) : calcRem(10),
    },
    marginBottom: themedValue(theme, {
        perthnow: calcRem(theme.margins.md),
        fallback: undefined,
    }),
}))

export const StyledWidgetRow = styled('section')<OlympicWidgetWrapStyleProps>(
    ({ isFullSize }) => ({
        margin: calcRem(10, 0),
        height: isFullSize ? calcRem(475) : calcRem(275),
        [breakpoint('sm')]: {
            height: isFullSize ? calcRem(850) : calcRem(275),
        },
    }),
)

export const StyledIframe = styled('iframe')(() => ({
    height: '100%',
    width: '100%',
    border: 'none',
    overflowX: 'hidden',
}))
